import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_tapgrabgo/artifacts/wnvvdlra_Logo%20Firefly%20Upscaler%204x%20scale%20copy.png";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isMobileMenuOpen
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <img
              src={LOGO_URL}
              alt="Grabo.ai"
              className="h-8 w-auto cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-sm font-medium text-gray-700 hover:text-[#2AD7C5] transition-colors"
            >
              How it Works
            </button>
            <button
              onClick={() => scrollToSection('use-cases')}
              className="text-sm font-medium text-gray-700 hover:text-[#2AD7C5] transition-colors"
            >
              Use Cases
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-medium text-gray-700 hover:text-[#2AD7C5] transition-colors"
            >
              About
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#2AD7C5] hover:bg-[#24c0b3] text-white rounded-full px-6 transition-all duration-200 hover:scale-105"
            >
              Book a Pilot
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-gray-200 bg-white">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#2AD7C5] transition-colors py-2"
            >
              How it Works
            </button>
            <button
              onClick={() => scrollToSection('use-cases')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#2AD7C5] transition-colors py-2"
            >
              Use Cases
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-sm font-medium text-gray-700 hover:text-[#2AD7C5] transition-colors py-2"
            >
              About
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-[#2AD7C5] hover:bg-[#24c0b3] text-white rounded-full transition-all duration-200"
            >
              Book a Pilot
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
